import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getProductGroupListData,
  getProductsData,
  getProductGroupOverviewData,
} from './mockData'
import type { IEntityParentChildrenObject, THrid } from '~/types/models'
import type {
  IProductGroup,
  IProductGroupOverview,
} from '~/types/product/models'

export const apiEntityPath = '/api/productgroups'

interface GetProductGroupsResponse {
  data: IProductGroup[]
}

async function getList(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`Returning productGroup list`)
  const responseBody: GetProductGroupsResponse = {
    data: await getProductGroupListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getProductsById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`Returning productGroup products for serviceGroup "${id}"`)
  const responseBody = { data: await getProductsData(id) }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetProductGroupOverviewResponse {
  data: IProductGroupOverview
}

async function getOverviewById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const obj = await getProductGroupOverviewData(id)
  if (obj) {
    console.log(`Returning overview for productGroup "${id}"`)
    const responseBody: GetProductGroupOverviewResponse = {
      data: obj,
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } else {
    const responseBody = { statusCode: 404, message: 'Resource not found.' }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

interface GetProductGroupParentChildResponse {
  data: IEntityParentChildrenObject
}

// post

const postProductGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getProductGroupListData)
}

const patchProductGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getProductGroupListData)
}

const deleteProductGroup = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getProductGroupListData)
}

export const handlers = [
  {
    method: 'get',
    path: apiEntityPath,
    handler: getList,
  },
  {
    method: 'get',
    path: '/api/productgroups/:id/overview',
    handler: getOverviewById,
  },
  {
    method: 'post',
    path: apiEntityPath,
    handler: postProductGroup,
  },
  {
    method: 'patch',
    path: '/api/productgroups/:id',
    handler: patchProductGroup,
  },
  {
    method: 'delete',
    path: '/api/productgroups/:id',
    handler: deleteProductGroup,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
